import { create } from 'zustand';
import type { Windows } from './windows/window.model';

export interface IWindowsState {
    closeWindow: (window: Windows) => void;
    focusWindow: (window: Windows) => void;
    minimizeWindow: (window: Windows) => void;
    openWindow: (window: Windows) => void;
    openWindows: Windows[];
    setStartMenu: (open: boolean) => void;
    startMenuOpen: boolean;
    toggleStartMenu: () => void;
    windows: Windows[];
}

export const useWindowsStore = create<IWindowsState>()((set, get) => ({
    closeWindow: (window) =>
        set((state) => ({
            openWindows: state.openWindows.filter((w) => w !== window),
            windows: state.windows.filter((w) => w !== window),
        })),

    focusWindow: (window) => {
        const { openWindows, windows } = get();
        if (!openWindows.includes(window)) {
            if (windows.includes(window)) {
                set({
                    openWindows: [window, ...openWindows],
                    startMenuOpen: false,
                });
            }
            return;
        }
        set({
            openWindows: [...openWindows.filter((w) => w !== window), window],
        });
    },

    minimizeWindow: (window) =>
        set((state) => ({
            openWindows: state.openWindows.filter((w) => w !== window),
            startMenuOpen: false,
        })),

    openWindow: (window) => {
        if (get().windows.includes(window)) {
            get().focusWindow(window);
            return;
        }
        set((state) => ({
            openWindows: [...state.openWindows, window],
            startMenuOpen: false,
            windows: [window, ...state.windows],
        }));
    },

    openWindows: [],

    setStartMenu: (startMenuOpen) => set({ startMenuOpen }),

    startMenuOpen: false,

    toggleStartMenu: () =>
        set((state) => ({ startMenuOpen: !state.startMenuOpen })),

    windows: [],
}));
